import { useState } from "react";
import apiClient from "../../../shared/API/apiClient";

const SendBackModal = ({ onClose, onConfirm, submission_id, reportingYearId }) => {
  const [comment,    setComment]    = useState("");
  const [error,      setError]      = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [apiError,   setApiError]   = useState("");

  const handleSendBack = async () => {
    if (!comment.trim()) { setError(true); return; }

    setSubmitting(true);
    setApiError("");
    try {
      await apiClient.post("/api/change-requested", {
        submission_id,
        reporting_year_id: reportingYearId,
        reviewer_comment:  comment,
        comment_type: "issue",
      });
      onConfirm(); // notify parent to refetch
      onClose();
    } catch (err) {
      console.error("Send-back error:", err);
      setApiError("Something went wrong. Please try again.");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="rv-modal-overlay" onClick={onClose}>
      <div className="rv-modal" onClick={(e) => e.stopPropagation()}>

        <div className="rv-modal__header">
          <span className="rv-modal__title">Send Back for Corrections</span>
          <button className="rv-modal__close" onClick={onClose}>×</button>
        </div>

        <div className="rv-modal__body">
          <label className="rv-modal__label">
            Comment <span className="rv-modal__required">*</span>
          </label>
          <textarea
            className={`rv-modal__textarea${error ? " rv-modal__textarea--error" : ""}`}
            placeholder="Describe what needs correction..."
            value={comment}
            rows={5}
            disabled={submitting}
            onChange={(e) => {
              setComment(e.target.value);
              if (e.target.value.trim()) setError(false);
            }}
          />
          {error && (
            <p className="rv-modal__hint">
              A comment is required when sending a module back.
            </p>
          )}
          {apiError && (
            <p className="rv-modal__hint" style={{ color: "#dc2626" }}>
              {apiError}
            </p>
          )}
        </div>

        <div className="rv-modal__footer">
          <button
            className="rv-btn rv-btn--ghost"
            onClick={onClose}
            disabled={submitting}
          >
            Cancel
          </button>
          <button
            className="rv-btn rv-btn--sendback"
            onClick={handleSendBack}
            disabled={submitting}
          >
            {submitting
              ? <><span className="va-action-btn__spinner" /> Sending…</>
              : "Send Back"
            }
          </button>
        </div>

      </div>
    </div>
  );
};

export default SendBackModal;